module.exports = __webpack_public_path__ + "static/img/one.8abefa4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoService/8/one.png
// module id = qO0Q
// module chunks = 1